import type { FC } from 'react'
import React from 'react'
import { Icon } from '../Icon'
import * as S from './PaymentProvidersIcons.styled'
import type { Props } from './types'
import { getIcons } from './utils'

export const PaymentProvidersIcons: FC<Props> = ({ type, size = 'normal' }) => {
  const isNative = (name: string) => name === 'ApplePay' || name === 'GooglePay'

  const getHeight = () => {
    if (size === 'small') {
      return 28
    }

    return 32
  }

  return (
    <S.Container>
      {getIcons(type).map(({ name, icon: IconComponent }) => (
        <S.ItemContainer key={name} $native={isNative(name)}>
          <Icon component={IconComponent} height={getHeight()} alt={name} />
        </S.ItemContainer>
      ))}
    </S.Container>
  )
}
